export default __webpack_public_path__ + "static/fulfilo-6f9bb282f1a96114db270b96d64568d9.svg";